import { getColorClasses } from "utils";
import { Badge } from "ui/components/badge";

export const TagBadge = ({ tag }) => {

    if (!tag) {
        return null;
    }

    const tagColor = tag.color || tag;
    const tagLabel = tag.label || tag;

    const colorClasses = getColorClasses(tagColor);

    return (
        <Badge className={colorClasses}>
            {tagLabel}
        </Badge>
    );
};
